/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */

import Collections from './reducer-collections';

export default Collections;


// WEBPACK FOOTER //
// ./src/reducers/collections/index.js